// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__32mxL"};